<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          icon="mdi-domain"
          :title="( id ? $i18n.t('Edit Allocation')+ ' - ' + allocation.name : $i18n.t('Create Allocation') )"
          color="primary"
          class="small-icon"
        >
          <v-form id="form" class="mx-2">
            <v-row>
              <v-col cols="6" md="3">
                <v-text-field :label="$i18n.t('Name')" v-model="allocation.name"></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <z-client-select
                  @input="fetchTariff(allocation.client_id)"
                  v-model="allocation.client_id"
                  :rules="validationrules.client"
                  clearable
                  required
                ></z-client-select>
              </v-col>

              <v-col cols="12" md="3">
                <v-checkbox v-model="allocation.autoAllocate" :label="$i18n.t('Auto Allocate')"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-card>
                  <v-list-item-content calss="px-3">
                    <v-row>
                      <v-col cols="12" md="4" class="mx-3">
                        <h3>{{ $i18n.t("For Rates") }}</h3>
                      </v-col>
                      <v-spacer />
                      <v-col clos="12" md="6">
                        <v-btn
                          @click="allocation.quotas = newItem(allocation.quotas)"
                          small
                          style="width:60px;float:right;"
                          color="light-blue"
                          text
                        >
                          <v-icon>mdi-plus</v-icon>
                          <h3>{{ $i18n.t("Add") }}</h3>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                  <v-simple-table dense style="padding: 10px">
                    <tbody>
                      <tr v-for="(quota, index) in allocation.quotas" :key="'quota' + index">
                        <td>
                          <v-select
                            :items="tariffs"
                            :label="$i18n.t('Tariff Select')"
                            class="purple-input"
                            v-model="quota.tariff_id"
                            :rules="validationrules.quotaTariff"
                            maxlength="20"
                            width="50"
                          ></v-select>
                        </td>
                        <td>
                          <v-btn
                            class="float-right"
                            color="error"
                            small
                            fab
                            text
                            dark
                            @click="remove(allocation.quotas, index)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      <v-spacer></v-spacer>
                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12">
                <v-card>
                  <v-list-item-content calss="px-3">
                    <v-row>
                      <v-col cols="12" md="4" class="mx-3">
                        <h3>{{ $i18n.t("Suppliers") }}</h3>
                      </v-col>
                      <v-spacer />
                      <v-col clos="12" md="6">
                        <v-btn
                          @click="allocation.suppliers = newItem(allocation.suppliers)"
                          small
                          style="width:60px;float:right;"
                          color="light-blue"
                          text
                        >
                          <v-icon>mdi-plus</v-icon>
                          <h3>{{ $i18n.t("Add") }}</h3>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                  <v-simple-table dense style="padding: 10px">
                    <tbody>
                      <tr
                        v-for="(supplier, index) in allocation.suppliers"
                        :key="'supplier' + index"
                      >
                        <td>
                          <z-vendor-select
                            :label="$i18n.t('Supplier')"
                            class="purple-input"
                            v-model="supplier.supplier_id"
                            :rules="validationrules.supplier"
                            maxlength="20"
                            width="50"
                            withSelf
                          ></z-vendor-select>
                        </td>
                        <td>
                          <v-text-field
                            :label="$i18n.t('Weightage')"
                            v-model="supplier.weightage"
                            type="number"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-btn
                            class="float-right"
                            color="error"
                            small
                            fab
                            text
                            dark
                            @click="remove(allocation.suppliers, index)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      <v-spacer></v-spacer>
                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12">
                <v-card>
                  <v-list-item-content calss="px-3">
                    <v-row>
                      <v-col cols="12" md="3" class="mx-3">
                        <h3>{{ $i18n.t("Vehicles") }}</h3>
                      </v-col>
                      <v-spacer />
                      <v-col clos="12" md="3">
                        <v-checkbox v-model="allocation.onDuty" :label="$i18n.t('On Duty Drivers')"></v-checkbox>
                      </v-col>
                      <v-spacer />
                      <v-col clos="12" md="3">
                        <z-vehicle-select ng-model="newVehicle" @input="newItemVehAlloc"></z-vehicle-select>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                  <v-simple-table dense style="padding: 10px">
                    <thead>
                      <tr>
                        <th class="primary--text">{{ $i18n.t("Vehicle") }}</th>
                        <th
                          class="primary--text"
                        >{{ $i18n.t("Slots (Enter Time Slot in ascending order)") }}</th>
                        <th class="primary--text">{{ $i18n.t("Owner") }}</th>
                        <th class="text-right primary--text">{{ $i18n.t("Action") }}</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="(vehcAllocate, index) in allocation.vehAllocations"
                        :key="'supplier' + index"
                      >
                        <td>
                          <span>
                            {{vehcAllocate.reg_No}}
                            <br />
                            {{vehcAllocate.veh_Type}}
                          </span>
                        </td>
                        <td>
                          <v-chip-group
                            v-for="(slot, i) in vehcAllocate.timeSlots"
                            :key="'slot' + i"
                          >
                            <z-time-picker
                              :label="$i18n.t('From')"
                              class="purple-input"
                              v-model="slot.fromTime"
                            />
                            <z-time-picker
                              :label="$i18n.t('Till')"
                              class="purple-input"
                              v-model="slot.tillTime"
                            />
                            <v-btn
                              class="float-right my-3"
                              color="error"
                              small
                              fab
                              text
                              dark
                              @click="vehcAllocate.timeSlots.splice(i, 1)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-chip-group>
                          <v-btn
                            v-show="!vehcAllocate.timeSlots || vehcAllocate.timeSlots.length < 3"
                            @click="vehcAllocate.timeSlots = newItem(vehcAllocate.timeSlots)"
                            x-small
                            color="teal"
                            fab
                            class="float-right"
                          >
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </td>
                        <td>
                          <span>{{vehcAllocate.owner}}</span>
                        </td>
                        <td>
                          <v-btn
                            class="float-right"
                            color="error"
                            small
                            fab
                            text
                            dark
                            @click="remove(allocation.vehAllocations, index)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      <v-spacer></v-spacer>
                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn color="info" class="mr-0" v-on:click="save()" :loading="loading">
                  <h3>{{ $i18n.t("Save") }}</h3>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class AllocationEdit extends Vue {
  allocation = {
    name: "",
    client_id: null,
    vehAllocations: [],
    suppliers: [],
    quotas: [],
  };
  id = null;
  isEdit = false;
  tariffs = [];
  vehicles = [];
  newVehicle = {};

  validationrules = {
    client: [(v) => !!v || this.$i18n.t("Client selction is required")],
    supplier: [(v) => !!v || this.$i18n.t("Supplier selction is required")],
    quotaTariff: [(v) => !!v || this.$i18n.t("Tariff selction is required")],
  };

  get loading() {
    return common.loading;
  }

  prepareTimeSlot() {
    if (
      this.allocation.vehAllocations &&
      this.allocation.vehAllocations.length > 0
    ) {
      for (let i = 0; i < this.allocation.vehAllocations.length; i++) {
        if (
          this.allocation.vehAllocations[i] &&
          !this.allocation.vehAllocations[i].veh_id
        ) {
          common.setError("Please select vehicle");
          return false;
        }
        if (
          this.allocation.vehAllocations[i] &&
          this.allocation.vehAllocations[i].timeSlots &&
          this.allocation.vehAllocations[i].timeSlots.length > 0
        ) {
          for (
            let j = 0;
            j < this.allocation.vehAllocations[i].timeSlots.length;
            j++
          ) {
            if (
              this.allocation.vehAllocations[i].timeSlots[j].fromTime >
              this.allocation.vehAllocations[i].timeSlots[j].tillTime
            ) {
              common.setError(
                "Start time should be less than End Time in Time Slot " +
                  this.allocation.vehAllocations[i].reg_No
              );
              return false;
            }
          }
        }
      }
    }

    if (
      this.allocation.vehAllocations &&
      this.allocation.vehAllocations.length > 0
    ) {
      for (let x = 0; x < this.allocation.vehAllocations.length; x++) {
        if (
          this.allocation.vehAllocations[x] &&
          this.allocation.vehAllocations[x].timeSlots &&
          this.allocation.vehAllocations[x].timeSlots.length > 0
        ) {
          for (
            let y = 0;
            y < this.allocation.vehAllocations[x].timeSlots.length - 1;
            y++
          ) {
            for (
              let z = y + 1;
              z < this.allocation.vehAllocations[x].timeSlots.length;
              z++
            ) {
              if (
                this.allocation.vehAllocations[x].timeSlots[y].fromTime &&
                this.allocation.vehAllocations[x].timeSlots[y].tillTime &&
                this.allocation.vehAllocations[x].timeSlots[z].fromTime &&
                this.allocation.vehAllocations[x].timeSlots[z].tillTime &&
                this.allocation.vehAllocations[x].timeSlots[y].tillTime >
                  this.allocation.vehAllocations[x].timeSlots[z].fromTime
              ) {
                common.setError(
                  "End Time should be less than Start Time of next Time slot in vehicle " +
                    this.allocation.vehAllocations[x].reg_No
                );
                return false;
              }
            }
          }
        }
      }
    }

    if (
      this.allocation &&
      this.allocation.vehAllocations &&
      this.allocation.vehAllocations.length > 0
    ) {
      for (let p = 0; p < this.allocation.vehAllocations.length; p++) {
        if (
          this.allocation.vehAllocations[p].timeSlots &&
          this.allocation.vehAllocations[p].timeSlots.length > 0
        ) {
          for (
            let q = 0;
            q < this.allocation.vehAllocations[p].timeSlots.length;
            q++
          ) {
            if (
              !this.allocation.vehAllocations[p].timeSlots[q].fromTime ||
              !this.allocation.vehAllocations[p].timeSlots[q].tillTime
            ) {
              this.remove(
                this.allocation.vehAllocations[p].timeSlots,
                this.allocation.vehAllocations[p].timeSlots[q]
              );
            }
          }
        }
      }
    }

    return true;
  }

  validateSuppliers() {
    if (
      this.allocation &&
      this.allocation.suppliers &&
      this.allocation.suppliers.length > 0
    ) {
      for (
        let i = 0;
        i < this.allocation.suppliers.length - 1 &&
        this.allocation.suppliers.length > 1;
        i++
      ) {
        for (let j = i + 1; j < this.allocation.suppliers.length; j++) {
          if (
            this.allocation.suppliers[i].supplier_id ==
            this.allocation.suppliers[j].supplier_id
          ) {
            common.setError("Multiple same supplier selected");
            return false;
          }
        }
      }
    }
    return true;
  }

  validateSave() {
    if (!this.allocation.quotas || this.allocation.quotas.length == 0) {
      common.setError("Please assign a Tariff");
      return;
    }

    if (!this.prepareTimeSlot()) {
      return false;
    }
    if (!this.validateSuppliers()) {
      return false;
    }
    return true;
  }

  async save() {
    try {
      if (!this.validateSave()) return;
      common.setLoading(true);
      this.allocation = await doPost("/api/allocation/save", this.allocation);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }
  async get(id) {
    try {
      this.allocation = await doGet("/api/allocation/" + id + "/detail");
      this.fetchTariff(this.allocation.client_id);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
      this.id = this.allocation._id;
    }
    // this.populateVehicles();
  }

  // async populateVehicles() {
  //   try {
  //     let url = "/api/vehicle/grid?rows=-1";
  //     if (this.allocation.suppliers && this.allocation.suppliers.length > 0) {
  //       url = url + "&vendor_ids=";
  //       this.allocation.suppliers.forEach(sup => {
  //         url = url + sup.supplier_id + ",";
  //       });
  //     }
  //     const data = await doGet(url);
  //     if (data.rows && data.rows.length > 0) {
  //       data.rows.forEach(tf => {
  //         this.vehicles.push({
  //           value: tf,
  //           text: tf.regNo
  //         });
  //       });
  //     }
  //   } catch (e) {
  //     common.setError(e.message);
  //   }
  // }

  async fetchTariff(client_id) {
    try {
      this.tariffs = [];
      const data = await doGet("/api/rates/client/" + client_id + "/list");
      if (data && data.length > 0) {
        data.forEach((tf) => {
          this.tariffs.push({
            value: tf._id,
            text: tf.name,
          });
        });
      }
    } catch (e) {
      common.setError(e.message);
    }
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }

  newItemVehAlloc(newVehicle) {
    if (!newVehicle || !newVehicle._id) return;
    if (!this.allocation.vehAllocations) this.allocation.vehAllocations = [];
    const data = {};
    data.timeSlots = [];
    data.veh_id = newVehicle._id;
    data.owner_id = newVehicle.corp_id;
    data.owner_id = newVehicle.corp_id;
    data.reg_No = newVehicle.regNo;
    data.veh_Type = newVehicle.vehicleType;
    data.owner = newVehicle.vendorName;
    this.allocation.vehAllocations.push(data);
    this.newVehicle = {};
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }
}
</script>
